import React from 'react';
import { Truck } from 'lucide-react';
import PolicyLayout, { Section, P, Li, Ul } from './PolicyLayout';

export default function ShippingPage() {
  return (
    <PolicyLayout
      title="Shipping & Delivery Policy"
      subtitle="Gold jewellery delivery, pickup, packaging & tracking"
      icon={Truck}
    >
      <Section title="Overview">
        <P>
          This policy applies to the physical delivery of gold jewellery redeemed through the
          Shine Jewellery investment platform. Investment credits and cash withdrawals are digital
          transfers and are not subject to this policy.
        </P>
      </Section>

      <Section title="Gold Redemption — Store Pickup">
        <Ul>
          <Li>Redeemed jewellery is available for in-store pickup at our registered store.</Li>
          <Li>
            You will be notified via SMS and app notification when your jewellery is ready for
            collection (typically 7–14 business days after redemption request approval).
          </Li>
          <Li>Carry a valid government-issued photo ID for identity verification at pickup.</Li>
          <Li>Collection hours: Monday – Saturday, 10:00 AM – 7:00 PM.</Li>
        </Ul>
      </Section>

      <Section title="Home Delivery (Select Locations)">
        <Ul>
          <Li>Home delivery is available for redemptions above ₹10,000 in select pin codes.</Li>
          <Li>Delivery is carried out via registered courier with full insurance coverage.</Li>
          <Li>Estimated delivery time: 5–7 business days after dispatch.</Li>
          <Li>A delivery charge of ₹99 applies for redemption orders below ₹25,000.</Li>
          <Li>Delivery is free for redemption orders of ₹25,000 and above.</Li>
          <Li>
            OTP-based delivery verification is mandatory. The OTP is sent to your registered
            mobile number at the time of delivery.
          </Li>
        </Ul>
      </Section>

      <Section title="Delivery Areas">
        <P>
          We currently deliver to major cities and towns across India. Enter your pin code during
          the gold redemption request to check delivery availability at your location. We are
          continuously expanding our delivery network.
        </P>
      </Section>

      <Section title="Packaging">
        <Ul>
          <Li>All jewellery is delivered in tamper-proof, branded Shine Jewellery packaging.</Li>
          <Li>
            Each piece comes with a Certificate of Authenticity and BIS hallmarking details
            confirming purity and weight.
          </Li>
          <Li>Weight and purity are verified, documented, and sealed before dispatch.</Li>
        </Ul>
      </Section>

      <Section title="Damaged or Missing Delivery">
        <Ul>
          <Li>
            If you receive a visibly damaged or tampered package, do not accept the delivery.
            Refuse it and report immediately to support@shinejewellery.in.
          </Li>
          <Li>
            For missing deliveries, raise a complaint within 48 hours of the expected delivery
            date with your order details and tracking number.
          </Li>
          <Li>
            All insured shipments are tracked end-to-end. We will assist in resolution within
            7 business days of complaint registration.
          </Li>
        </Ul>
      </Section>

      <Section title="Order Tracking">
        <P>
          Once your jewellery is dispatched, a shipment tracking ID will be shared via SMS on
          your registered mobile number and via the Platform notification. You can use this ID
          on the courier partner's website to track your delivery in real time.
        </P>
      </Section>

      <Section title="Contact for Delivery Issues">
        <P>Email: support@shinejewellery.in</P>
        <P>Phone: +91 XXXXX XXXXX</P>
        <P>Support hours: Monday – Saturday, 10:00 AM – 6:00 PM</P>
      </Section>
    </PolicyLayout>
  );
}
